import clsx from "clsx";
import React, { useMemo } from "react";
import { BtnPropsType } from "../@types/button";

function Button(props: BtnPropsType) {
  const {
    color,
    endIcon,
    children,
    startIcon,
    isLoading,
    className,
    isDisabled,
    size = "md",
    isLoadingText,
    ...other
  } = props;

  return (
    <button
      className={clsx(
        "btn",
        { isLoading },
        `btn-${color}`,
        size && `btn-${size}`,
        isDisabled && "disabled",
        className
      )}
      {...other}
    >
      {startIcon}
      {isLoadingText || children}
      {endIcon}
    </button>
  );
}

const Transparent = (props: BtnPropsType) => {
  const { color = "primary" } = props;
  return <Button className={`btn-outline-${color}`} {...props} />;
};
Button.Transparent = Transparent;

const Link = (props: BtnPropsType) => {
  return <Button className="btn-link" {...props} />;
};
Button.Link = Link;

type GroupBtnType = {
  dir?: "vertical" | "horizontal";
} & BtnPropsType;

const Group = (props: GroupBtnType) => {
  const { children, dir = "horizontal" } = props;

  const groupChild = useMemo(() => {
    const element = [];
    if (children) {
      for (
        let i = 0;
        typeof children !== "string" || i < children.length;
        i++
      ) {
        if (children[i] && children[i].type === Button) {
          const { props: itemProps } = children[i];
          element.push(<Button {...itemProps} />);
        }
      }
    }
    return element;

  }, [children]);

  return (
    <div className={dir === "horizontal" ? "btn-group" : "btn-group-vertical"}>
      {groupChild}
    </div>
  );
};
Button.Group = Group;

export default Button;
